// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_show-grab-cursor_1fgk7_1nqmi_1 *:not(#\\9){cursor:grabbing}.awsui_show-resize-cursor_1fgk7_1nqmi_5 *:not(#\\9){cursor:nwse-resize}.awsui_disable-selection_1fgk7_1nqmi_9 *:not(#\\9){-webkit-user-select:none;user-select:none}\n", ""]);
// Exports
module.exports = exports;
